import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@mui/material';

export const ItemField = forwardRef(({
  value, endAdornment, editText, onChange, readOnly, errored, id, margin,
}, ref) => {
  const dislayValue = useMemo(
    () => {
      if (editText !== null) return editText;
      return value ? value.repr : '';
    },
    [editText, value],
  );
  return (
    <Input
      id={id}
      ref={ref}
      value={dislayValue}
      onChange={(e) => onChange(e, e.target.value)}
      readOnly={readOnly}
      endAdornment={endAdornment}
      error={errored}
      fullWidth
      margin={margin}
    />
  );
});

export const valuePropType = PropTypes.shape({
  id: PropTypes.number,
  repr: PropTypes.string,
});

ItemField.propTypes = {
  id: PropTypes.string,
  endAdornment: PropTypes.element,
  value: valuePropType,
  editText: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  errored: PropTypes.bool,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
};

ItemField.defaultProps = {
  id: null,
  value: { id: null, repr: '' },
  endAdornment: null,
  editText: null,
  onChange: () => null,
  readOnly: false,
  errored: false,
  margin: 'dense',
};

export default ItemField;
